/* eslint-disable @typescript-eslint/no-unused-vars */
import { inject } from '@angular/core';
import { CanMatchFn, Route, UrlSegment } from '@angular/router';
import { AccessRight, RouteData } from '@constants/enum';
import { AuthService } from './auth.service';

/**
 * Guard to check if the user has any or all of the required access rights for the route.
 * Access rights must be defined in the route data as:
 * [RouteData.PropAnyRights]: [AccessRight.***, ...]
 * or [RouteData.PropAllRights]: [AccessRight.***, ...]
 */
export const accessRightsGuard: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
  const authService = inject(AuthService);

  if (route.data) {
    if (
      Array.isArray(route.data[RouteData.PropAnyRights]) &&
      !authService.hasAnyRights(route.data[RouteData.PropAnyRights] as AccessRight[])
    ) {
      return false;
    }

    if (
      Array.isArray(route.data[RouteData.PropAllRights]) &&
      !authService.hasAllRights(route.data[RouteData.PropAllRights] as AccessRight[])
    ) {
      return false;
    }
  }

  return true;
};
